module.exports = __webpack_public_path__ + "img/panas.defad56c.png";